<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Activity Fees Component</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="activity_fees_component_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-btn class="ma-2 no-display" rounded outlined small color="success"
                    @click="downloadFile" :loading="loader"><v-icon>mdi-export</v-icon>Export</v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small dense class="button" v-on="on">Add Activity Fees Component</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.activity_fee_component_name" label="Activity Fees Component"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.activity_fee_component_name" dense persistent-hint outlined
                           label="Activity Fees Component"></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                            <v-icon color="error">*</v-icon>
                         <v-autocomplete dense required v-model="addedItem.activity_id"
                          :items="activity_list" item-text="activity_title" item-value="activity_id" label="Select Activity Name" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>  
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense required v-model="editedItem.activity_id"
                          :items="activity_list" item-text="activity_title" item-value="activity_id" label="Select Activity Name" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions style="justify-content:  center;">
                  <!-- <v-spacer></v-spacer> -->
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.isactive="{ item }">
        <v-switch inset dense v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
        </template>
        <template v-slot:item.status="{ item }">
          <span v-if="item.isactive==true">
            <v-icon class="mr-2 pl-3 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 pl-3 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
             <v-avatar style="" size="25" class="edit-avatar ml-2">
                <v-icon class="v-icon-size mr-2 ml-2"  @click="deleteItem(item)">delete</v-icon>
             </v-avatar>
             <!-- <v-switch v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'" @change="toggle(item)"></v-switch> -->  
          </div>
          </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import * as XLSX from "xlsx";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      activity_fee_component_name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    activity_list:[],
    search: "",
    dialog: false,
    headers: [
      {
        text: "Activity Fees Component",
        align: "left",
        sortable: false,
        value: "activity_fee_component_name",
      },
      {
        text: "Activity",
        align: "left",
        sortable: false,
        value: "activity",
      },
      {
        text: "Active",
        align: "center",
        sortable: true,
        value: "isactive",
      },
       {
        text: "Status",
        align: "center",
        sortable: true,
        value: "status",
      },
      { text: "Actions", value: "action", sortable: false,align: "center"},
    ],
    activity_fees_component_list: [],
    editedIndex: -1,
    addedItem: {
      activity_fee_component_name: "",
    },
    editedItem: {
      id: "",
      activity_fee_component_name: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      activity_fee_component_name: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Activity Fees Component"
        : "Edit Activity Fees Component";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.feesComponent = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Activity/getActivityFeesComponent")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            // this.activity_type_super_master_list =
            //   res.data.activity_type_super_master_list;
            this.activity_fees_component_list = res.data.activity_fees_component_list;
            this.activity_list=res.data.activity_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
     downloadFile() {
    this.loader = true;

    const excelData = this.activity_fees_component_list.map((item, index) => ({
      "S.No": index + 1,
      "Name": item.activity_fee_component_name,
      "Status": item.isactive ? "Active" : "Inactive"
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Activity Fees Component");
    XLSX.writeFile(workbook, "activity_fees_component.xlsx");

    this.loader = false;
  },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.activity_fees_component_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

     deleteItem(item) {
      if (confirm("Are you sure you want to delete this Activity Fees Component?")) {
      const data = {
        id: item.id
      };
      axios
        .post("/Activity/deleteActivityFeesComponent", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Activity Fees Component Deleted Successfully...");
            this.onLoad();
          }
           else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      }
      this.close();
    },


    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Activity/editActivityFeesComponent", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.activity_fees_component_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Activity Fees Component Updated successfully..."
                ); 
                this.onLoad();
              }
             else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Activity Fees Component already present!!!"); // show snackbar on error
              this.onLoad();
            }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              this.addedItem.activity_fee_component_name = "";
            });

          this.close();
        }
      } else {
        if(this.addedItem.activity_fee_component_name=="" || this.addedItem.activity_fee_component_name==null){
            this.showSnackbar("#b71c1c", "Please enter Activity Fees Component...");
            return
        }
        axios
          .post("/Activity/saveActivityFeesComponent", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.activity_fees_component_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Activity Fees Component added successfully..."
              ); 
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Activity Fees Component already present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.addedItem.activity_fee_component_name = "";
          });

        this.close();
      }
    }, 

    isValidated() {
      if (this.editedItem.activity_fee_component_name) {
        return true;
      } else {
        if (!this.editedItem.activity_fee_component_name) {
           this.showSnackbar("#b71c1c", "Please enter Activity Fees Component...");
          this.errorMsg.activity_fee_component_name = true;
        }

        return false;
      }
    },
        toggle(item) {
      const data = {
        id: item.id,
        isactive: item.isactive
      };
      axios
        .post("/Activity/toggleActivityFeesComponent", data)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Activity Fees Component Updated Successfully...");
            this.onLoad();
          }
           else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      this.close();
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.active-switch-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.active-switch-container .v-switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.mytable ::v-deep tbody tr{
   min-height:50px;
}

.mytable ::v-deep tbody td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>
